import { IContainer } from '../../interface/container';
import { injectConfigAPI, injectConfigCache } from '../../interface/config';
import { injectMediaAPI } from '../../api/interface/bind';
import { IWorkspaceDB } from '../../db/interface';
import { IMediaManagerInstantiator } from '../interface/media';
import { IAuthenticationManager } from '../interface/auth';
import MediaManager from './media';

function bind(container: IContainer): IMediaManagerInstantiator {
    const mediaAPI = injectMediaAPI(container);
    const configAPI = injectConfigAPI(container);
    const configCache = injectConfigCache(container);

    return {
        open: (db: IWorkspaceDB, auth: IAuthenticationManager) =>
            MediaManager(db, auth, mediaAPI, configAPI, configCache),
    };
}

export default bind;
